// extracted by mini-css-extract-plugin
module.exports = {"description":"SponsorshipsSlide_description__7sUIa","imageWrapper":"SponsorshipsSlide_imageWrapper__EjGCl","imageWrapperModal":"SponsorshipsSlide_imageWrapperModal__5jWyM"};